import { h } from "preact";
import { classNames } from "../../platform/preact/class-names.ts";
import type { IconProps } from "./icon.tsx";

export function IconBrand({ className, ...props }: Omit<IconProps, "icon">) {
  return (
    <svg
      className={classNames(
        "component-icon",
        "component-icon-brand",
        className,
      )}
      {...props}
      viewBox="0 0 640 640"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_211_3)">
        <circle cx="320" cy="320" r="320" fill="#5686fe" />
        <path
          d="M475.337 133.63C482.684 133.036 489.883 135.856 495.079 141.051C500.274 146.247 503.094 153.446 502.501 160.794C499.532 197.383 489.587 254.458 468.137 309.008C466.801 312.348 464.055 314.872 460.567 315.911L400.524 333.946C397.63 334.837 395.7 337.434 395.7 340.477C395.7 344.262 398.743 347.305 402.528 347.305H431.176C440.083 347.305 445.797 356.805 441.196 364.45C438.227 369.423 435.036 374.247 431.77 378.997C430.286 381.149 428.059 382.708 425.536 383.524L353.024 405.196C350.13 406.087 348.2 408.684 348.2 411.727C348.2 415.512 351.243 418.555 355.028 418.555H366.903C377.739 418.555 382.489 431.469 373.434 437.407C322.965 470.805 271.235 469.544 238.059 460.637C228.633 458.114 220.247 453.29 212.528 447.352L158.2 501.68C151.669 508.212 140.981 508.212 134.45 501.68C127.919 495.149 127.919 484.462 134.45 477.93L193.825 418.555L194.196 418.926C194.715 417.962 195.383 417.071 196.2 416.255L312.575 299.805C319.106 293.274 319.106 282.587 312.575 276.055C306.044 269.524 295.356 269.524 288.825 276.055L189.149 375.657C182.544 382.262 171.337 378.923 170.594 369.571C167.403 330.087 177.497 278.208 224.477 231.227C292.09 163.614 413.141 138.676 475.262 133.63H475.337Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_211_3">
          <rect width="640" height="640" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
